import { agentsConstants } from '@constants/agents';
import { agentsService } from '@services';

function request() {
    return { type: agentsConstants.AGENTS_FETCH };
}

function success(data) {
    return { type: agentsConstants.AGENTS_SUCCESS, data };
}

function failure() {
    return { type: agentsConstants.AGENTS_ERROR };
}

const get = () => {
    return dispatch => {
        dispatch(request());
        agentsService.get().then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

function update(data) {
    return { type: agentsConstants.AGENTS_UPDATE, data };
}

export const agentsActions = {
    get,
    update,
};
